import { supabase } from '@/lib/supabase/supabaseClient';
import { GetProjectByIdProps } from '.';
import { sortInProjectRoleOrder } from '@/features/rbac/lib/sortByRole';

export const getProjectById = async ({ projectId }: GetProjectByIdProps) => {
  if (!projectId) throw new Error('projectId is required');

  const projectData = await supabase
    .from('project')
    .select(
      `
            *,
            project_members(user_id, user(id, first_name, last_name, email, signed_up)),
            crm_project(
                *,
                crm(
                    *,
                    crm_config(*)
                )
            ),
            manager:user!project_manager_id_fkey(
                first_name,
                last_name
            ),
            organisation(
                organisation_members(*),
                name
            ),
            crm(*)
        `
    )
    .eq('id', projectId)
    .maybeSingle()
    .throwOnError()
    .then((res) => res.data);

  if (!projectData) throw new Error('Project not found');

  const memberRows = projectData.project_members || [];
  const userIds = memberRows.map((m) => m.user_id);

  const rolesData = await supabase
    .from('user_project_role')
    .select(
      'user_id, project_role_id, project_id, role:role_based_project_access_control(*)'
    )
    .in('user_id', userIds)
    .eq('project_id', projectId)
    .throwOnError()
    .then((res) => res.data);

  if (!rolesData) throw new Error('Error fetching project roles');

  const membersWithRoles = memberRows.map((m) => ({
    ...m,
    user: m.user,
    role: rolesData.find((r) => r.user_id === m.user_id)?.role || null,
  }))
  .sort((a, b) => sortInProjectRoleOrder(a.role?.role, b.role?.role))
  return {
    ...projectData,
    project_members: membersWithRoles,
  };
};
